import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { ReactComponent as TabScrollChevron } from '../../../assets/TabScrollChevron.svg';
import { ReactComponent as TooltipPointer } from '../../../assets/TooltipPointer.svg';
import classes from './BotsCarouselMore.module.css';

export default function BotsCarouselMore({ count, hiddenNames = [], onClick, className = '' }) {
  const wrapRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
  const canShowTooltip = showTooltip && hiddenNames.length > 0;

  useLayoutEffect(() => {
    if (!canShowTooltip || !wrapRef.current) return;
    const rect = wrapRef.current.getBoundingClientRect();
    setTooltipPos({
      top: rect.top + rect.height / 2,
      left: rect.right + 4,
    });
  }, [canShowTooltip, hiddenNames.length]);

  if (count <= 0) return null;

  return (
    <div
      ref={wrapRef}
      className={[classes.Wrap, className].filter(Boolean).join(' ')}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {canShowTooltip ?
        createPortal(
          <div
            className={classes.TooltipFrame}
            role="tooltip"
            style={{
              top: tooltipPos.top,
              left: tooltipPos.left,
            }}
          >
            <TooltipPointer className={classes.TooltipArrow} aria-hidden="true" />
            <div className={classes.Tooltip}>
              {hiddenNames.map((name, index) =>
                <span key={`${name}-${index}`} className={classes.TooltipName}>{name}</span>
              )}
            </div>
          </div>,
          document.body
        )
        : null}
      <button
        type="button"
        className={classes.Button}
        onClick={onClick}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        aria-label={`+${count}`}
        aria-expanded={canShowTooltip}
      >
        <span className={classes.Count}>+{count}</span>
        <TabScrollChevron className={classes.Chevron} aria-hidden="true" />
      </button>
    </div>
  );
}
